import { autoCapitalize } from '@/utils/autoCapitalize'
import { CollectionAttemptsListTypes } from './CollectionAttempsOrOutcome.types'

class CollectionAttemptsListMapper {
  toDomain(persistenceData: CollectionAttemptsListTypes) {
    return {
      collectionId: persistenceData?.id,
      transactionId: persistenceData?.idTransacaoNovo || '',
      date: persistenceData?.dataHora,
      actionPerformed: autoCapitalize(persistenceData?.acaoRealizada),
      status: autoCapitalize(persistenceData?.status),
      userName: autoCapitalize(persistenceData?.nomeUsuario),
      userId: persistenceData?.idUsuario,
    }
  }
}

export default new CollectionAttemptsListMapper()
